module.exports = __webpack_public_path__ + "img/design_2.6dfbdb80.png";